import React from 'react'
type AppProps = {
    labourLawDetails: any;
    handleLabourLawDetailsChange: (data: any) => void;
    isDisabled?:boolean
}
const LabourLaw = ({
    labourLawDetails,
    handleLabourLawDetailsChange,
    isDisabled
}: AppProps) => {
    return (
        <>
            <div className='row'>
                <div className="col-md-3">
                    <label htmlFor="professionalTaxEmployee">Professional Tax Employee</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="text"
                            className="form-control"
                            name="professionalTaxEmployee"
                            value={labourLawDetails?.professionalTaxEmployee}
                            onChange={handleLabourLawDetailsChange}
                             disabled={isDisabled}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <label htmlFor="professionalTaxEmployer">Professional Tax Employer</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="text"
                            className="form-control"
                            name="professionalTaxEmployer"
                            value={labourLawDetails?.professionalTaxEmployer}
                            onChange={handleLabourLawDetailsChange}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <label htmlFor="epfo">EPFO</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="text"
                            className="form-control"
                            name="epfo"
                            value={labourLawDetails?.epfo}
                            onChange={handleLabourLawDetailsChange}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default LabourLaw